import React, { FunctionComponent, useContext } from 'react'
import { Accordion } from '../../../components/integration-builder/accordion'
import styles from '../integration-builder.module.css'
import { Tooltip, Link } from '@paypalcorp/pp-react'
import { CheckoutSimulatorContext } from '../../../components/integration-builder/context/CheckoutSimulatorContext'
import { ExternalLink } from '../../../components/icons'

const TakeLive: FunctionComponent = () => {
  const { integrationType } = useContext(CheckoutSimulatorContext)

  return (
    <div className={styles.checkout_simulator__accordion_container}>
      <Accordion
        number={4}
        color="secondary"
        heading="Take your application live"
        defaultCollapsed
        content={
          <>
            <div className={styles.checkout_simulator__subtitle_wrapper}>
              <p className={styles.checkout_simulator__fragment_subtitle}>
                Move your application to PayPal's live environment
              </p>
              <Tooltip
                name="tooltip1"
                description="Your payers won't be able to use checkout until you move your application to the live environment."
                windowId="window1"
                imagePosition="bottom-left"
              />
            </div>
            {integrationType === 'advanced' ? (
              <ol>
                <li>
                  Copy the sample code based on your front-end and back-end
                  framework to your checkout page.
                </li>
                <li>Customize your code (optional).</li>
                <li>
                  Get your Live credentials from the{' '}
                  <span>
                    <Link
                      target="_blank"
                      href="/dashboard/"
                      className={styles.integration_builder__external_link}
                    >
                      Developer Dashboard
                    </Link>
                    <ExternalLink />.
                  </span>
                  Replace 'CLIENT_ID' and 'APP_SECRET' in the front-end and
                  back-end files with your own app's Client ID and App Secret.
                </li>
                <li>
                  In Live App Settings, go to Accept Payments {'>'} Advanced
                  Options. Make sure the Advanced Credit and Debit Card Payments
                  checkbox is checked.
                </li>
                <li>Test your live integration.</li>
              </ol>
            ) : (
              <ol>
                <li>
                  Ensure your application adheres to the{' '}
                  <span>
                    <Link
                      target="_blank"
                      href="/reference/guidelines/policiesAndGuidelines/"
                      className={styles.integration_builder__external_link}
                    >
                      PayPal Application Policies and Guidelines
                    </Link>
                    <ExternalLink />.
                  </span>
                </li>
                <li>Obtain your live credentials.</li>
                <li>
                  Replace your test credentials in your integration with your
                  live credentials.
                </li>
                <li>Update your PayPal endpoint.</li>
              </ol>
            )}
          </>
        }
      />
    </div>
  )
}

export default TakeLive
